<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="菜单级别">
                <a-select v-model="queryParam.level">
                  <a-select-option value="SYSTEM">
                    系统级
                  </a-select-option>
                  <a-select-option value="BUSINESS">
                    业务级
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="代码"
                ><a-input v-model="queryParam.permCode" placeholder=""
              /></a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="loadData">查询</a-button>
                <a-button
                  type="primary"
                  icon="plus"
                  @click="showModal('add')"
                  class="button-margin-left"
                  v-hasAnyPermission="`permission:add`"
                  >新建</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = { level: 'SYSTEM' })"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
      >
        <span slot="type" slot-scope="text">
          <a-tag :color="text == '1' ? '#87d068' : '#108ee9'">
            {{ text == "1" ? "menu" : "button" }}
          </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`permission:edit`"
              >编辑</a
            >
            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`permission:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
            <a
              class="a-action"
              v-hasAnyPermission="`permission:child`"
              @click="action(record, 'child')"
              v-if="record.type == '1'"
              >添加子项</a
            >
          </template>
        </span>
      </a-table>
    </a-card>

    <!-- 弹出框 -->
    <a-modal
      v-model="modal.visible"
      :title="modal.title"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="资源名称" prop="permName">
          <a-input v-model="formData.permName" :maxLength="20" />
        </a-form-model-item>
        <a-form-model-item label="资源代码" prop="permCode">
          <a-input
            :addon-before="formData.prefix"
            v-model="formData.permCode"
            :maxLength="20"
            :disabled="modal.type == 'edit' ? true : false"
          />
        </a-form-model-item>
        <a-form-model-item label="类型" prop="type">
          <a-select
            @change="handleTypeChange"
            v-model="formData.type"
            :disabled="
              modal.type == 'add' || modal.type == 'edit' ? true : false
            "
          >
            <a-select-option :value="1">
              菜单
            </a-select-option>
            <a-select-option :value="2">
              按钮
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="菜单级别" prop="level">
          <a-select
            v-model="formData.level"
            :disabled="modal.type == 'edit' ? true : false"
          >
            <a-select-option value="SYSTEM">
              系统级
            </a-select-option>
            <a-select-option value="BUSINESS">
              业务级
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="资源地址" prop="permUrl">
          <a-input v-model="formData.permUrl" />
        </a-form-model-item>
        <a-form-model-item label="图标" prop="permUrl">
          <a-input v-model="formData.icon" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="listOrder">
          <a-input-number v-model="formData.listOrder" :min="1" :max="99999" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-view>
</template>

<script>
import moment from "moment";
import { PageView } from "@/layouts";
export default {
  name: "PermissionList",
  components: {
    PageView
  },
  data() {
    return {
      // 查询参数
      queryParam: {
        level: "SYSTEM"
      },
      // 表头
      columns: [
        {
          title: "名称",
          dataIndex: "permName"
        },
        {
          title: "代码",
          dataIndex: "permCode"
        },
        {
          title: "类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" }
        },
        {
          title: "等级",
          dataIndex: "level"
        },
        {
          title: "图标",
          dataIndex: "icon"
        },
        {
          title: "排序",
          dataIndex: "listOrder"
        },
        {
          title: "操作时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      tableData: [],
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        permName: "",
        permCode: "",
        permUrl: "",
        type: 1,
        level: "SYSTEM",
        icon: "",
        listOrder: 1,
        prefix: ""
      },
      //form rules
      rules: {
        permName: [
          {
            required: true,
            message: "请输入资源名称",
            trigger: "change"
          }
        ],
        permCode: [
          {
            required: true,
            message: "请输入资源代码",
            trigger: "change"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change"
          }
        ],
        level: [
          {
            required: true,
            message: "请选择菜单级别",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    // 加载数据方法 必须为 Promise 对象
    loadData() {
      this.$http.systemBksApi.listPermission(this.queryParam).then(res => {
        this.tableData = res.resultObject;
      });
    },
    action(record, type) {
      if (type == "child") {
        this.showModal(type);
        this.formData.pcode = record.permCode;
      } else if (type == "edit") {
        this.showModal(type);
        this.formData = Object.assign({}, record);
      } else if (type == "del") {
        this.$http.systemBksApi
          .deletePermissionByCode({ code: record.permCode })
          .then(res => {
            if (res.result == 0) {
              this.loadData();
              this.$message.success(res.msg);
            }
          });
      }
    },
    showModal(type) {
      this.modal.visible = true;
      if (type == "edit") {
        this.modal.title = "编辑资源";
      } else {
        this.modal.title = "添加资源";
      }
      this.modal.type = type;
    },
    handleTypeChange(v) {
      if (v == 2 && this.modal.type == "child" && this.formData.pcode) {
        this.formData.prefix = this.formData.pcode + ":";
      } else {
        this.formData.prefix = "";
      }
    },
    cancel() {
      this.formData.prefix = "";
      this.formData = {
        type: 1,
        level: "SYSTEM",
        listOrder: 1
      };
      this.$refs.ruleForm.resetFields();
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          let action = "";
          if (this.modal.type == "add" || this.modal.type == "child") {
            action = "savePermission";
            if (param.type == "2") {
              param.permCode = param.prefix + param.permCode;
            }
          } else {
            action = "modifyPermission";
          }
          this.$http.systemBksApi[action](param).then(res => {
            if (res.result == 0) {
              this.modal.visible = false;
              this.cancel();
              this.loadData();
              this.$message.success(res.msg);
            }
          });
        }
      });
    }
  }
};
</script>
